export default {
  navigation: {
    home: 'Home Page',
    compatible: 'Compatibility',
    question: 'Troubleshooting',
    feedback: 'Questions and Feedback',
    product: 'Product Showcase',
    course: 'Replacement Video Tutorial',
    goBack: 'Return to Homepage',
    en: 'English',
    cn: 'Chinese',
    menu: 'Menu',
    switchLanguage: 'Switch Language',
  },
  home: {
    title: 'SHOKZ POP User Guide',
    desc: 'Provides full user guides, installation tutorials, and technical support for your display system.',
    videoTitle: 'POP3.5 Series Parts Replacement Video Tutorial',
    videoTitleOpenDots2: 'OpenDots 2 Series Tutorial',
    productListTitle: 'POP3.5 series display',
    productListDesc: 'It supports new features added to new products such as OpenFit Pro, and is optimized based on POP3.0, supporting modular changes.',
    newTag: 'Recommended for new arrivals',
    productListTitle2: 'Standard series display',
    classicTag: 'Classic series display',
    classicDesc: 'A mature product display line, suitable for most SHOKZ headphone models.'
  },
  product: {
    installWarning: 'If you encounter installation difficulties, please refer to the accompanying video tutorial or contact our technical support team.',
    standardDisplay: 'Standard Display',
    standardSeriesDisplay: 'Standard Series Display',
    multiProductDisplay: 'Multi-Product Desktop Display',
    cabinetDisplay: 'Shelf Display',
    hangingDisplay: 'Hook Display',
    hangingCombinationDisplay: 'Endcap Display',
    tankDisplay: 'Water Tank Display',
    displayDesc: 'Display Introduction',
    installDesc: 'How to Install',
    replaceDesc: 'How to Replace',
    backToList: 'Return to Display List',
    productDesc: 'Product Introduction',
    productDisplay: 'Product Showcase',
    techSpec: 'Product Specifications',
    dimension: 'Dimensions',
    netWeight: 'Net Weight',
    grossWeight: 'Gross Weight',
    packageDimension: 'Package Size',
    material: 'Materials',
    applicableScene: 'Applicable Scenarios',
    compatibleProduct: 'Compatible Products',
    compatibleProductDesc: 'The following products can be displayed on the Openfit standard display. Click on the product card to view the display effect .',
    installGuide: 'Installation Guide',
    installGuideDesc: 'Please follow these steps to install your display rack correctly. Before installation, make sure your work area is clean and tidy, with enough space to operate safely.',
    installMaterial: 'Installation Material',
    installVideo: 'Installation Video',
    installVideoDesc: 'Please watch the detailed installation video tutorial.',
    installVideoBtn: 'Watch Video',
    installManual: 'Installation Manual',
    installManualDesc: 'Please download the detailed installation instructions PDF.',
    installManualBtn: 'Download PDF',
    installManualImg: 'Installation Diagram',
    installManualImgDesc: 'Refer to the diagram for the installation steps.',
    installManualImgBtn: 'View Larger Image',
    prepareWork: 'Preparation Work',
    prepareWorkDesc1: 'Check that all accessories listed in the package are included.',
    prepareWorkDesc2: 'Prepare the installation tools (usually included in the package).',
    prepareWorkDesc3: 'Choose a suitable location for installation.',
    prepareWorkDesc4: 'Make sure the installation surface is level and secure.',
    installStep: 'Installation Steps',
    prepareBase: "Preparing Basics",
    prepareBaseDesc: 'Place the display stand base in the designated position, ensuring the ground is level, and use a level to check if the base is level.',
    assembleScaffold: 'Assembly Bracket',
    assembleScaffoldDesc: 'Insert the support column into the base, aligning it in the direction of the arrow, and then tighten the fixing screws. Ensure the bracket is vertical and stable.',
    installShowBoard: 'Installation Display Board',
    installShowBoardDesc: 'Secure the display to the stand using the provided fasteners. Ensure the display is fully aligned with the stand.',
    fixProduct: 'Fixed Display',
    fixProductDesc: 'Place the headphones on the display board as instructed in the manual, and use the provided clips or brackets to secure the product in place.',
    checkAdjust: 'Inspection and Adjustment',
    checkAdjustDesc: 'Check that all connections are secure and that the display angle is appropriate. Make any necessary minor adjustments to ensure the best possible display effect.',
    checkAdjustList: 'Post-Installation Checklist',
    checkAdjustItem1: 'Ensure all screws are fully tightened.',
    checkAdjustItem2: 'Confirm the display stand is stable and does not wobble.',
    checkAdjustItem3: 'Verify that the product is securely fixed.',
    checkAdjustItem4: 'Adjust to a suitable display angle.',
    checkAdjustItem5: 'Ensure the overall appearance is clean and organized.',
    replaceGuide: 'Replacement Guide',
    replaceGuideDesc: 'When you need to replace displayed products or service the display stand, follow the steps below.',
    replaceGuideDesc2: 'OpenDots 2 series replacing the TF card refer to <a href="/opendots2TFcard" rel="noopener noreferrer">https://support.shokz.com/opendots2TFcard</a>',
    replaceMaterial: 'Replace Material',
    replaceVideo: 'Replacement Video',
    replaceVideoDesc: 'Watch detailed product replacement video tutorials',
    replaceVideoBtn: 'Watch Video',
    replaceManual: 'Replacement Manual',
    replaceManualDesc: 'Download the detailed replacement instructions (PDF).',
    replaceManualBtn: 'Download PDF',
    replaceManualImg: 'Replacement Diagram',
    replaceManualImgDesc: 'See the diagram illustrating the replacement steps.',
    replaceManualImgBtn: 'View Larger Image',
  },
  course: {
    series: 'Series',
    seriesPartsTutorialDesc1: 'Learn how to replace accessories on POP',
    seriesPartsTutorialDesc2: 'series display stands to keep them in optimal condition.',
    seriesPartsTutorialDesc1OpenDots2: 'Learn how to replace accessories on OpenDots 2',
    seriesPartsTutorialDesc2OpenDots2: 'series display stands to keep them in optimal condition.',
    seriesPartsTutorial: 'Series Parts Replacement Video Tutorial',
    clickDisplayStand: 'Click on the display card below to watch the corresponding accessory replacement tutorial video.',
    selectDisplayStand: 'Select Display Model',
    partsTutorial: 'Parts Replacement Video Tutorial',
    courseDesc: 'Video Tutorial Tnstructions',
    courseDesc1: 'Each video details the replacement steps for the corresponding display stand model.',
    courseDesc2: 'The video includes complete operating procedures and safety precautions.',
    courseDesc3: 'It is recommended to watch the entire video before replacing any parts to ensure correct operation.',
    courseDesc4: 'If you have any questions, please contact our technical support team.',
    courseTips: 'Before replacing any parts, ensure you have the necessary replacement components and tools ready. It is recommended to watch a complete video tutorial before beginning.',
    courseTipsDesc1: 'This video demonstrates in detail the steps for replacing accessories on a POP',
    courseTipsDesc2: ' display stand, including how to replace the listening stand, listening headphones, and back panel display.',
    courseTipsDesc1OpenDots2: 'This video demonstrates in detail the steps for replacing accessories on a OpenDots 2',
    courseTipsDesc2OpenDots2: 'series display stands, including how to replace the listening stand, listening headphones, and back panel display.',
  },
  compatible: {
    compatibleTitle1: '兼容不同的耳机',
    compatibleDesc1: '以下产品型号与我们的展示架兼容',
    compatibleTitle2: '兼容性说明',
    compatibleDesc2: '我们的展示架设计考虑了 SHOKZ 全线产品的展示需求。不同型号的展示架可能对特定产品有更好的适配性，建议根据您的产品组合选择合适的展架型号。'
  },
  feedback: {
    title: 'Problem Feedback',
    greeting: 'Dear Users:',
    content1: 'Shokz values your privacy. AI the information you provide to us is only used to improve our products and services. We will take technical measures and other necessary measures(such as anonymization) to store your information securely.',
    content2: 'We respect and protect your privacy. We will never sell or share this information to any third party without your explicit consent. By taking the surveys, you agree that we may process your data under your authorization. If you have any requirements, please contact us.',
    content3: 'You can also view the Privacy Policy of this Site at any time by going to the bottom of the homepage of the website.',
    enterBtn: 'Enter',
  },
  question: {
    pageTitle: 'Troubleshooting',
    pageDesc: 'Common issues and solutions',
    problem1Title: 'Problem 1: Ring light flashes rapidly and the 4 button lights do not light up',
    problem1Cause1Title: 'Possible Cause 1:',
    problem1Cause1Reason: 'Headphones are not properly connected',
    problem1Cause1Solution1: '1. Open the demo/test station (refer to the "How to Replace" section for operating instructions).',
    problem1Cause1Solution2: '2. Unplug the headphones\' USB Type-C connector, then firmly reinsert it to ensure a secure connection.',
    problem1Cause1Solution3: '3. Observe whether the issue is resolved. If normal operation resumes, troubleshooting is complete.',
    problem1Cause2Title: 'Possible Cause 2:',
    problem1Cause2Reason: 'Headphones are faulty or damaged',
    problem1Cause2Solution: 'Replace the headphones with a new, functional unit.',
    
    problem2Title: 'Problem 2: The four button LEDs flash rapidly, but the ring LED remains off',
    problem2Cause1Title: 'Possible Cause 1:',
    problem2Cause1Reason: 'TF card is not properly inserted',
    problem2Cause1Solution1: '1. Open the demo/test station (refer to the "How to Replace" section for instructions).',
    problem2Cause1Solution2: '2. Remove the microSD (TF) card and reinsert it firmly to ensure a secure connection.',
    problem2Cause1Solution3: '3. Check if the device returns to normal operation. If the issue is resolved, troubleshooting is complete.',
    problem2Cause2Title: 'Possible Cause 2:',
    problem2Cause2Reason: 'TF card is corrupted or damaged',
    problem2Cause2Solution: 'Replace the microSD (TF) card with a new, compatible one.',
    
    problem3Title: 'Problem 3: Back panel LEDs are unlit, but audio playback on the display stand works normally',
    problem3Cause1Title: 'Possible Cause 1:',
    problem3Cause1Reason: 'Power cable for the back panel lighting is disconnected or loose',
    problem3Cause1Solution: 'Inspect and ensure the power cable connected to the back panel LEDs is securely plugged in.',
    problem3Cause2Title: 'Possible Cause 2:',
    problem3Cause2Reason: 'Incompatible power adapter is being used (e.g., POP2.0 5V adapter)',
    problem3Cause2Solution: 'Replace the current adapter with the correct POP3.0 12V power adapter',
    problem3Cause3Title: 'Possible Cause 3:',
    problem3Cause3Reason: 'Poor connection between the back panel LED cable and the control box ("black box")',
    problem3Cause3Solution: 'Check the connector where the back panel cable interfaces with the control box. Re-seat the cable firmly to ensure stable contact.',
    problem3Cause4Title: 'Possible Cause 4:',
    problem3Cause4Reason: 'Display stand (or its internal lighting circuit) is faulty',
    problem3Cause4Solution: 'Replace the display stand with a new unit.',
    
    problem4Title: 'Problem 4: No Response from the Entire Audio Playback Module of the Display Stand',
    problem4Cause1Title: 'Possible Cause 1:',
    problem4Cause1Reason: 'Possible systemic short circuit; restarting the display stand system is generally recommended',
    problem4Cause1Solution1: '1. Replug the TF card and check if the function is restored. If restored, troubleshooting ends.',
    problem4Cause1Solution2: '2. Replug the headset and check if the function is restored. If restored, troubleshooting ends.',
    problem4Cause1Solution3: '3. Replug the power supply and check if the function is restored. If restored, troubleshooting ends.',
    problem4Cause2Title: 'Possible Cause 2:',
    problem4Cause2Reason: 'Poor contact between the key light cable and the black box',
    problem4Cause2Solution: 'Replug the key light cable on the black box',
    problem4Cause3Title: 'Possible Cause 3:',
    problem4Cause3Reason: 'Internal circuit fault of the display stand',
    problem4Cause3Solution: 'Contact after-sales service to replace the display stand with a new one',
    
    problem5Title: 'Problem 5: No sound from the headset, while other modules such as the buttons and back panel function normally.',
    problem5Cause1Title: 'Possible Cause 1:',
    problem5Cause1Reason: 'TF card malfunction',
    problem5Cause1Solution: 'Replace the TF card with a new one',
    problem5Cause2Title: 'Possible Cause 2:',
    problem5Cause2Reason: 'Headset is damaged',
    problem5Cause2Solution: 'Replace the headset with a new one',
    
    problem6Title: 'Problem 6: POP earphones have abnormal volume, hollow sound, and poor sound quality',
    problem6Cause1Title: 'Possible Cause 1:',
    problem6Cause1Reason: 'Mismatch between display stand and headset models (e.g. S820 headset paired with S710 display stand)',
    problem6Cause1Solution: 'Replace the current headset with one compatible with the upgrade board',
    problem6Cause2Title: 'Possible Cause 2:',
    problem6Cause2Reason: 'Headset is damaged',
    problem6Cause2Solution: 'Replace the headset with a new one',
    
    problem7Title: 'Problem 7: No Sound from the Headset After Replacing with One Equipped with Upgrade Board',
    problem7Reason: 'The headset with upgrade board has not been successfully upgraded',
    problem7Solution: 'The headset requires a certain period of time to complete the upgrade process when connected to the POP. The upgrade is considered successful only when the four key lights turn on sequentially, or wait for approximately 1 minute.',
    
    problem8Title: 'Problem 8: Headset Deformation – Commonly Seen in Ear Clip and Ear Hook Products',
    problem8Product1: 'Ear Hook Products:',
    problem8Product1Solution1: 'Slight deformation: Perform manual correction',
    problem8Product1Solution2: 'Severe deformation: Replace the headset with a new one',
    problem8Product2: 'Ear Clip Products:',
    problem8Product2Solution1: 'Slight deformation: Perform manual correction',
    problem8Product2Solution2: 'Severe deformation: Replace the headset with a new one',
    
    causeLabel: 'Reason:',
    solutionLabel: 'Solution:',
    questionTitle: 'Unable to solve the problem?',
    questionDesc: 'If the above solutions do not resolve your issue, please contact our technical support team:',
    questionEmail: 'Email',
    questionContact: 'Please provide the following information when contacting us:',
    questionDesc1: 'Display model and purchase date',
    questionDesc2: 'Detailed description of the problem',
    questionDesc3: 'Solutions already tried',
    questionDesc4: 'Other relevant information (such as error messages, screenshots, etc.)',
    submitBtn: 'Submit Feedback',
  },
  video: {
    title: 'Video Player',
    notSupported: 'Your browser does not support video playback',
    watchVideo: 'Watch Video',
    loading: 'Loading video...',
    playError: 'Video playback failed, please try again',
  },
  footer: {
    support: 'Professional Display User Guide and Support Services',
    quickLinks: 'Quick Links',
    legalInfo: 'Legal Information',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',
  },
  privacy: {
    title: 'Privacy Policy',
    effectiveDate: 'Effective date: 2024/4/11',
    introTitle: 'INTRODUCTION',
    intro1: 'Shokz Co., Ltd. and its affiliated companies under common ownership and control within the Shokz family of companies (collectively, "Shokz", "we", "our" or "us") respect the privacy of the viewer/visitor/user ("you"). Your privacy is important to Shokz so we\'ve developed this Privacy Policy. We have revamped the Privacy Policy front and back so that from the effective date onwards, this Privacy Policy can provide privacy details on how we manage your personal information for all Shokz products and services, unless a separate privacy policy is provided for a specific Shokz product or service.',
    intro2: 'This Privacy Policy contains the following sections:',
    toc1: 'Our Commitment to You',
    toc2: 'The Information We Collect and How We Use It',
    toc3: 'Legal Bases for Use of Your Information',
    toc4: 'Device Permission Request',
    toc5: 'Cookies and Similar Technologies',
    toc6: 'How We Share and Disclose Your Information',
    toc7: 'Security Safeguards',
    toc8: 'Retention of Your Information',
    toc9: 'Data Subject Rights and Your Choices',
    toc10: 'Additional Information for Certain Jurisdictions',
    toc11: 'Transfer of Personal Information Outside of Your Jurisdiction',
    toc12: 'Children\'s Privacy',
    toc13: 'Third-Party Links and Features',
    toc14: 'Updates to the Privacy Policy',
    toc15: 'Contact Us',
    contactEmail: 'privacy@shokz.com',
    contactPhone: '737-215-4011',
    contactAddress1: 'Shenzhen Shokz Co., Ltd.',
    contactAddress2: 'Floors 1-4, Factory Building 26, Shancheng Industrial Park, Shixin Community',
    contactAddress3: 'Shiyan Street, Bao\'an District, Shenzhen, Guangdong, China',
    contactAddress4: 'Postal Code: 518017',
  }
}